/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [

    {
        id: 'Master',
        title: 'Master',
        // subtitle: 'Unique dashboard designs',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'dashboards.analytics',
                title: 'Partner View',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/partner'
            }, {
                id: 'dashboards.analytics',
                title: 'User View',
                type: 'basic',
                icon: 'heroicons_outline:user-circle',
                link: '/user'
            }, {
                id: 'dashboards.analytics',
                title: 'Role View',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/role'
            }, {
                id: 'dashboards.analytics',
                title: 'Menu View',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-2',
                link: '/menu'
            },
        ]
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'customer',
        title: 'Dashboard',
        // subtitle: 'Unique dashboard designs',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/dashboards/customer'
    },

    {
        id: 'cv',
        title: 'Customer Verification',
        tooltip: 'Customer Verification',
        type: 'basic',
        icon: 'heroicons_outline:check-circle',
        link: '/CustomerVerification'
    },

    {
        id: 'MoslSearch',
        title: 'MOSL Search',
        tooltip: 'MOSL Search',
        type: 'basic',
        icon: 'heroicons_outline:collection',
        link: '/MoslSearch'
    },
    {
        id: 'Quotation',
        title: 'Quotation',
        tooltip: 'Quotation',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/quotation'
    },
    {
        id: 'idfs',
        title: 'Industry Dataflow Search',
        tooltip: 'Industry Dataflow Search',
        type: 'basic',
        icon: 'heroicons_outline:trending-up',
        link: '/flowprocess'
    },
    {
        id: 'Contractupload',
        title: 'Contract Upload',
        tooltip: 'Contract Upload',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/contractupload'
    },
   
    {
        id: 'industryflow',
        title: 'Industry Flow',
        tooltip: 'Industry Flow',
        type: 'collapsable',
        icon: 'heroicons_outline:presentation-chart-line',
        children: [
            {
                id: 'T103_R',
                title: 'T103-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add103R'
            }, {
                id: 'T105_R',
                title: 'T105-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add105R'
            }, {
                id: 'T108_R',
                title: 'T108-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add108R'
            }, {
                id: 'T110_R',
                title: 'T110-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add110R'
            }, {
                id: 'T112_R',
                title: 'T112-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add112R'
            }, {
                id: 'T125_R',
                title: 'T125-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add125R'
            }, {
                id: 'T132_R',
                title: 'T132-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add132R'
            }, {
                id: 'T134_R',
                title: 'T134-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add134R'
            }, {
                id: 'T141_R',
                title: 'T141-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add141R'
            }, {
                id: 'T142_R',
                title: 'T142-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add142R'
            }, {
                id: 'T146_R',
                title: 'T146-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add146R'
            }, {
                id: 'T156_R',
                title: 'T156-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add156R'
            }, {
                id: 'T160_R',
                title: 'T160-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add160R'
            }, {
                id: 'T162_R',
                title: 'T162-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/add162R'
            }, {
                id: 'TCORR171_R',
                title: 'TCORR171-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/addTCORR171R'
            }
            , {
                id: 'TCORR172_R',
                title: 'TCORR172-R',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/flow/addTCORR172R'
            }
        ] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'Pricing Utility',
        title: 'Pricing Utility',
        tooltip: 'Utility',
        type: 'collapsable',
        icon: 'heroicons_outline:presentation-chart-line',
        children: [
            {
                id: 'PricingUtility',
                title: 'FBW Base Overhead Margin',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/Fbwbaseoverheadmargin'
            }, {
                id: 'Wholesaler_Price',
                title: 'Wholesaler Price Matrix',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/Fbwbaseoverheadmargin/WholesalerPriceMatrix'
            }
        ] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'Master',
        title: 'Master',
        tooltip: 'Master',
        type: 'collapsable',
        icon: 'heroicons_outline:menu-alt-4',
        children: [
            {
                id: 'dashboards.analytics',
                title: 'Partner View',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/partner'
            }, {
                id: 'dashboards.analytics',
                title: 'User View',
                type: 'basic',
                icon: 'heroicons_outline:user-circle',
                link: '/user'
            }, {
                id: 'dashboards.analytics',
                title: 'Role View',
                type: 'basic',
                icon: 'heroicons_outline:badge-check',
                link: '/role'
            }, {
                id: 'dashboards.analytics',
                title: 'Menu View',
                type: 'basic',
                icon: 'heroicons_outline:menu-alt-2',
                link: '/menu'
            },
        ] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },

];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'customer',
        title: 'Dashboard',
        // subtitle: 'Unique dashboard designs',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/dashboards/customer'
    },

    {
        id: 'cv',
        title: 'Customer Verification',
        tooltip: 'Customer Verification',
        type: 'basic',
        icon: 'heroicons_outline:check-circle',
        link: '/CustomerVerification'
    },

    {
        id: 'MoslSearch',
        title: 'MOSL Search',
        tooltip: 'MOSL Search',
        type: 'basic',
        icon: 'heroicons_outline:collection',
        link: '/MoslSearch'
    },
    {
        id: 'Quotation',
        title: 'Quotation',
        tooltip: 'Quotation',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/quotation'
    },
    
    {
        id: 'Master',
        title: 'Master',
        tooltip: 'Master',
        type: 'collapsable',
        icon: 'heroicons_outline:menu-alt-4',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
